import axios from "axios";
import { endPoint } from "../../config/EndPoint";
import { LOGIN, GET_USER_NAME, GET_USER, LOGOUT_USER } from "../types/Types";
import { toast } from "react-toastify";

export const loginUserName = (setLoading, username) => async (dispatch) => {
  try {
    dispatch({ type: GET_USER_NAME, payload: username });
    setLoading(false);
  } catch (error) {
    console.log("error", error);
  } finally {
    setLoading(false);
  }
};

export const loginAction = (setLoading, data) => async (dispatch) => {
  try {
    setLoading(true);
    let loginUser = await axios.post(`${endPoint}/auth/login/`, data);
    if (loginUser?.data?.access) {
      localStorage.setItem("user", JSON.stringify(loginUser.data));
      dispatch({ type: LOGIN, payload: loginUser.data });
    }
  } catch (error) {
    if (error.response.data.username) {
      toast.error(`User name - ${error.response.data.username[0]}`);
    } else if (error.response.data.detail) {
      toast.error(`${error.response.data.detail}`);
    } else {
      toast.error("Something went wrong");
    }
  } finally {
    setLoading(false);
  }
};

export const getUser = (setLoading) => async (dispatch) => {
  try {
    setLoading(true);
    let user = await localStorage.getItem("user");
    user = JSON.parse(user);
    if (user.access) {
      dispatch({ type: GET_USER, payload: user });
    }
  } catch (error) {
    console.log("error", error);
  } finally {
    setLoading(false);
  }
};

export const userLogout = (setLoading) => async (dispatch) => {
  try {
    localStorage.removeItem("user");
    dispatch({ type: LOGOUT_USER });
  } catch (error) {
    console.log("error", error);
  } finally {
    setLoading(false);
  }
};
